<template>
    <div class="cell-wrapper display-flex align-items-center" style="width: fit-content">
        <div class="link-wrapper h-100 display-flex align-items-center" style="width: fit-content">
            <div
                v-if="params.data?.color"
                class="color-chip mr-sm"
                :style="{ background: params.data.color }"
            ></div>
            <div
                class="ultimate-parent mr-md"
                v-if="params.data?.ultimateEntityName"
                v-tooltip="{
                    content: `Ultimate Parent - ${params.data.ultimateEntityName}`,
                    placement: 'top',
                    distance: '-5',
                }"
            >
                <font-awesome-icon class="text-primary-darker" icon="fas fa-buildings" />
            </div>
            <div
                class="company-click-area display-flex align-items-center"
                @click.left.prevent="showPopover = true"
            >
                <a
                    class="popper-hook link text-truncate"
                    :href="entityRouteLink(getEntityId())"
                    target="_blank"
                >
                    {{ params.value }}
                </a>
            </div>
        </div>
        <div
            v-if="params.data?.stockTicker"
            class="ticker display-inline-flex align-items-center ml-sm p-xxs bg-stone-50"
        >
            <p class="small">{{ params.data.stockTicker }}</p>
        </div>
        <CompanyPopover
            :show-popover="showPopover"
            :passed-company-details="params.entityOverwrite ? params.entityOverwrite : params.data"
            @close-popover="showPopover = false"
        />
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import CompanyPopover from '../helpers/CompanyPopover.vue'
import { entityRouteLink } from '../../router/utils'

const props = defineProps({
    params: {
        type: Object,
        required: true,
    },
})

const getEntityId = () =>
    props.params.entityOverwrite?.aonEntityPk ||
    props.params.data.aonEntityPk ||
    props.params.data.aon_entity_pk ||
    props.params.data.entityPk ||
    props.params.data.entityId

const showPopover = ref(false)
</script>

<style lang="scss" scoped>
@use '@moatmetrics/armory/src/sass/token-utils' as tokens;

.cell-wrapper {
    .color-chip {
        width: 20px;
        height: 20px;
        border-radius: var(--border-radius-full);
    }
}
.ticker {
    border-radius: var(--border-radius-md);
    transition: all ease-in-out 0.3s;

    span {
        color: var(--color-text-primary);
        transition: all ease-in-out 0.3s;
    }
}
</style>
